/**
 * `VITE_LEGACY_ORIGINS` (comma-separated) as origins; anything that isn't a url is
 * dropped. Its own module so vite.config.ts can use it (for the service worker's list)
 * without the app's runtime.
 */
export function parseOrigins(raw: string): string[] {
	return raw
		.split(',')
		.map((s) => {
			try {
				return new URL(s.trim()).origin;
			} catch {
				return '';
			}
		})
		.filter((o) => o !== '' && o !== 'null');
}
